import { event } from '@ice/stark-data';
import moment from 'moment';
import CONSTANTS from '@/utils/constant';

const currentDate = moment();
let timer;// 函数防抖函数使用【debounceImmediately】

// 退订文案长度
const CANCELWDLENGTH = CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3; // 3是文案前的空格和签名的中括号

export default {
  key() {
    return String(Math.random()).substring(2, 10);
  },
  // 时间筛选
  dateFormat(timestamp, formats) {
    // formats格式包括
    // 1. Y-m-d
    // 2. Y-m-d H:i:s
    // 3. Y年m月d日
    // 4. Y年m月d日 H时i分
    formats = formats || 'Y-m-d';

    const zero = function (value) {
      if (value < 10) {
        return `0${value}`;
      }
      return value;
    };

    const myDate = timestamp ? new Date(timestamp) : new Date();

    const year = myDate.getFullYear();
    const month = zero(myDate.getMonth() + 1);
    const day = zero(myDate.getDate());

    const hour = zero(myDate.getHours());
    const minite = zero(myDate.getMinutes());
    const second = zero(myDate.getSeconds());

    return formats.replace(/Y|m|d|H|i|s/gi, (matches) => {
      return {
        Y: year,
        m: month,
        d: day,
        H: hour,
        i: minite,
        s: second,
      }[matches];
    });
  },
  delay(time, callback) {
    setTimeout(() => {
      callback();
    }, time);
  },
  // 计算字符串长度, 合理返回null, 不合理返回str...
  Len(str) {
    let sum = 0;
    let num = null;
    for (let i = 0; i < str.length; i++) {
      if ((str.charCodeAt(i) >= 0) && (str.charCodeAt(i) <= 255)) {
        sum += 1;
      } else {
        sum += 2;
      }

      if (sum >= 18) {
        num = str.length === 9 ? null : i + 1;
        break;
      }
    }
    return num;
  },
  // 深拷贝
  deepObj(obj) {
    return JSON.parse(JSON.stringify(obj));
  },
  // 获取标签自定义属性
  getAttribute(target, option) {
    const obj = {};
    option.forEach((val) => {
      obj[val.substring(5)] = target.getAttribute(val);
    });
    return obj;
  },
  // 短信模板 模板状态
  parseFormStatus(status) {
    switch (status) {
      case '-1':
        return {
          text: '审核中',
          color: 'gray_color',
        };
      case '1':
        return {
          text: '审批通过',
          color: 'success_color',
        };
      case '0':
        return {
          text: '审批不通过',
          color: 'error_color',
        };
      default:
        return {
          text: '',
          color: 'gray_color',
        };
    }
  },
  // 短信模板 模板状态
  ParseTemplateType(status) {
    switch (status) {
      case '0':
        return '日常营销';
      case '618':
        return '618';
      case '61':
        return '六一';
      case '55':
        return '端午';
      case '77':
        return '七夕';
      case '815':
        return '中秋节';
      case '1001':
        return '国庆节';
      case '1111':
        return '双11';
      case '88':
        return '会员日';
      case '365':
        return '周年庆';
      default:
        return '';
    }
  },
  // 复制到粘贴板
  copyText(text) {
    return new Promise((resolve) => {
      const tag = document.createElement('input');
      tag.setAttribute('id', 'cp_hgz_input');
      tag.value = text;
      document.getElementsByTagName('body')[0].appendChild(tag);
      document.getElementById('cp_hgz_input').select();
      document.execCommand('copy');
      document.getElementById('cp_hgz_input').remove();
      resolve();
    });
  },
  // 从cookie里获取bdVenderType 判断是否为pop店
  getCookie(cookieName) {
    const allcookies = document.cookie;
    // 索引长度，开始索引的位置
    let cookiePos = allcookies.indexOf(cookieName);

    // 如果找到了索引，就代表cookie存在,否则不存在
    if (cookiePos !== -1) {
      // 把cookie_pos放在值的开始，只要给值加1即可
      // 计算取cookie值得开始索引，加的1为“=”
      cookiePos = cookiePos + cookieName.length + 1;
      // 计算取cookie值得结束索引
      let cookieEnd = allcookies.indexOf(';', cookiePos);

      if (cookieEnd === -1) {
        cookieEnd = allcookies.length;
      }
      // 得到想要的cookie的值
      const newValue = unescape(allcookies.substring(cookiePos, cookieEnd));
      return newValue;
    }
    return '';
  },
  getWeek(date) {
    const _date = new Date(date);
    // getDay() 返回表示星期的某一天
    const num = _date.getDay(_date);
    let week;
    switch (num) {
      case 0:
        week = '周日';
        break;
      case 1:
        week = '周一';
        break;
      case 2:
        week = '周二';
        break;
      case 3:
        week = '周三';
        break;
      case 4:
        week = '周四';
        break;
      case 5:
        week = '周五';
        break;
      case 6:
        week = '周六';
        break;
      default:
        break;
    }

    return { week, num };
  },
  // 格式化数字，带千分位
  numFormat(num) {
    if (!num) {
      return 0;
    }
    const res = num.toString().replace(/\d+/, (n) => { // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
        return `${$1 },`;
      });
    });
    return res;
  },

  /**
   * 为数字加千位分隔符 - 过滤器 -hjy添加
   * @param num
   */
  numFormat_hjy(num: number): string | 0 {
    if (!num) {
      return 0;
    }
    const res = num.toString().replace(/\d+/, (n) => {
      // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => {
        return `${$1 },`;
      });
    });
    return res;
  },

  /**
   * 设置Header面包屑
   * @param breadcrumb
   */
  setBreadcrumb(breadcrumb: {}): void {
    /** 传参示例 */
    // const Breadcrumb = {
    //   name: "",//一级页面名称
    //   url: "",//一级页面url
    //   children: {
    //     name: "",//二级页面名
    //     url: "",//二级页面url
    //     children: {
    //       name: "",//三级页面名
    //       url: "",//三级页面url
    //       //...
    //     }
    //   }
    // };
    event.emit('Breadcrumb', breadcrumb);
  },

  /**
   * 禁止选择某些日期（默认向后禁用日期且不包括当天）
   * @param {moment.Moment} date 时间列表中的项
   * @param {string} view 当前组件渲染的类型
   * @param {string} disableDire 时间禁用方向 ==> front-向前禁用 / back-向后禁用
   * @param {boolean} disableCurrent 是否禁用当前日期（今天/本周/本年）
   * @returns {Boolean} Boolean
   */
  disabledDate(date: moment.Moment, view: string, disableDire = 'back', disableCurrent = false): boolean {
    // 第一层分类 - 判别当前时间选择组件生成的是类型是哪种 ==> date-时间选择器 / year-年份选择器 / month-月份选择器
    switch (view) {
      case 'date':
        // 第二层分类 - 判断时间禁用方向 及是否禁用当前日期
        switch (disableDire) {
          case 'front':
            return disableCurrent ? date.valueOf() < currentDate.valueOf() : date.valueOf() < (currentDate.valueOf() - 86400000);
          case 'back':
            return disableCurrent ? date.valueOf() > currentDate.valueOf() : date.valueOf() >= currentDate.valueOf();
          default:
            return false;
        }

      case 'year': // 没有验证过效果 - 请以实际使用时修改为准
        switch (disableDire) {
          case 'front':
            return disableCurrent ? date.year() < currentDate.year() : date.year() <= currentDate.year();
          case 'back':
            return disableCurrent ? date.year() > currentDate.year() : date.year() >= currentDate.year();
          default:
            return false;
        }

      case 'month': // 没有验证过效果 - 请以实际使用时修改为准
        switch (disableDire) {
          case 'front':
            return disableCurrent ? date.year() * 100 + date.month() < currentDate.year() * 100 + currentDate.month() : date.year() * 100 + date.month() <= currentDate.year() * 100 + currentDate.month();
          case 'back':
            return disableCurrent ? date.year() * 100 + date.month() > currentDate.year() * 100 + currentDate.month() : date.year() * 100 + date.month() >= currentDate.year() * 100 + currentDate.month();
          default:
            return false;
        }

      default:
        return false;
    }
  },

  /**
   * 防抖函数 - 立即执行
   * @param func 需要执行的函数
   * @param wait - 拦截 wait 时间内相同的请求
   *
   * @description
   * 使用方法：如下 创建一个函数
   *  const responseFunc = (func, ...argu) => {
   *    utils.debounceImmediately(func)(argu);
   *  }
   *
   *  @description 在组件标签中加入点击事件
   *  onClick={() => responseFunc(FuncName, "参数1", "参数2","...")}
   */
  debounceImmediately(func, wait = 500) {
    const that = this;
    return function (param) {
      if (timer) clearTimeout(timer);
      const callNow = !timer;
      timer = setTimeout(() => {
        timer = null;
      }, wait);
      if (callNow) func.apply(that, arguments);
    };
  },

  // 校验短信特殊字符
  stringVerification(Countent) {
    //20250410 李嘉需求 特殊字符校验全部取消
    // const specialSymbol = '❤❥웃유♋☮✌☏☢☠✔☑♚▲♪✈✞÷↑↓◆◇⊙■□△▽¿─│♥❣♂♀☿Ⓐ✍✉☣☤✘☒♛▼♫⌘☪≈←→◈◎☉★☆⊿※¡━┃♡ღツ☼☁❅♒✎©®™Σ✪✯☭➳卐√↖↗●◐Θ◤◥︻〖〗┄┆℃℉°✿ϟ☃☂✄¢€£∞✫★½✡×↙↘○◑⊕◣◢︼【】┅┇☽☾✚〓▂▃▄▅▆▇█▉▊▋▌▍▎▏↔↕☽☾の•▸◂▴▾┈┊①②③④⑤⑥⑦⑧⑨⑩ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ㍿▓♨♛❖♓☪✙┉┋☹☺☻تヅツッシÜϡﭢ™℠℗©®♥❤❥❣❦❧♡۵웃유ღ♋♂♀☿☼☀☁☂☄☾☽❄☃☈⊙☉℃℉❅✺ϟ☇♤♧♡♢♠♣♥♦☜☞☝✍☚☛☟✌✽✾✿❁❃❋❀⚘☑✓✔√☐☒✗✘ㄨ✕✖✖⋆✢✣✤✥❋✦✧✩✰✪✫✬✭✮✯❂✡★✱✲✳✴✵✶✷✸✹✺✻✼❄❅❆❇❈❉❊†☨✞✝☥☦☓☩☯☧☬☸✡♁✙♆ˆˇ•¨～—ˉ｜‖＂〃｀@﹫¡¿﹏﹋﹌︴々﹩$﹠&*﹡﹢﹦﹤‐￣¯―﹨ˆ˜﹍﹎+=<＿_ˇ﹉﹊〈〉‹›﹛﹜『』〖〗［］《》〔〕{}「」【】︵︷︿︹︽_﹁﹃︻︶︸﹀︺︾ˉ﹂﹄︼☩☨☦✞✛✜✝✙✠✚†‡◉○◌◍◎●◐◑◒◓◔◕◖◗❂☢⊗⊙◘◙◍⅟½⅓⅕⅙⅛⅔⅖⅚⅜¾⅗⅝⅞⅘≂≃≄≅≆≇≈≉≊≋≌≍≎≏≐≑≒≓≔≕≖≗≘≙≚≛≜≝≞≟≠≡≢≣≤≥≦≧≨≩⊰⊱⋛⋚∫∬∭∮∯∰∱∲∳℅㊣㊎㊍㊌㊋㊏㊐㊊㊚㊛㊤㊥㊦㊧㊨㊒㊞㊑㊒㊓㊔㊕㊖㊗㊘㊜㊝㊟㊠㊡㊢㊩㊪㊫㊬㊭㊮㊯㊰㊙㉿囍♔♕♖♗♘♙♚♛♜♝♞♟ℂℍℕℙℚℝℤℬℰℯℱℊℋℎℐℒℓℳℴ℘ℛℭ℮ℌℑℜℨ♪♫♩♬♭♮♯°øⒶ☮✌☪✡☭✯卐✐✎✏✑✒✍✉✁✂✃✄✆✉☎☏➟➡➢➣➤➥➦➧➨➚➘➙➛➜➝➞➸♐➲➳⏎➴➵➶➷➸➹➺➻➼➽←↑→↓↔↕↖↗↘↙↚↛↜↝↞↟↠↡↢↣↤↥↦↧↨➫➬➩➪➭➮➯➱↩↪↫↬↭↮↯↰↱↲↳↴↵↶↷↸↹↺↻↼↽↾↿⇀⇁⇂⇃⇄⇅⇆⇇⇈⇉⇊⇋⇌⇍⇎⇏⇐⇑⇒⇓⇔⇕⇖⇗⇘⇙⇚⇛⇜⇝⇞⇟⇠⇡⇢⇣⇤⇥⇦⇧⇨⇩⇪➀➁➂➃➄➅➆➇➈➉➊➋➌➍➎➏➐➑➒➓㊀㊁㊂㊃㊄㊅㊆㊇㊈㊉ⒶⒷⒸⒹⒺⒻⒼⒽⒾⒿⓀⓁⓂⓃⓄⓅⓆⓇⓈⓉⓊⓋⓌⓍⓎⓏⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫⅬⅭⅮⅯⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅺⅻⅼⅽⅾⅿ┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋╌╍╎╏═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬◤◥◄►▶◀◣◢▲▼◥▸◂▴▾△▽▷◁⊿▻◅▵▿▹◃❏❐❑❒▀▁▂▃▄▅▆▇▉▊▋█▌▍▎▏▐░▒▓▔■□▢▣▤▥▦▧▨▩▪▫▬▭▮▯㋀㋁㋂㋃㋄㋅㋆㋇㋈㋉㋊㋋㏠㏡㏢㏣㏤㏥㏦㏧㏨㏩㏪㏫㏬㏭㏮㏯㏰㏱㏲㏳㏴㏵㏶㏷㏸㏹㏺㏻㏼㏽㏾㍙㍚㍛㍜㍝㍞㍟㍠㍡㍢㍣㍤㍥㍦㍧㍨㍩㍪㍫㍬㍭㍮㍯㍰㍘☰☲☱☴☵☶☳☷☯♠♣♧♡♥❤❥❣♂♀✲☀☼☾☽◐◑☺☻☎☏✿❀№↑↓←→√×÷★℃℉°◆◇⊙■□△▽¿½☯✡㍿卍卐♂♀✚〓㎡♪♫♩♬㊚㊛囍㊒㊖Φ♀♂‖$@*&※卍卐Ψ♫♬♭♩♪♯♮⌒¶∮‖€￡¥$②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳⓪❶❷❸❹❺❻❼❽❾❿⓫⓬⓭⓮⓯⓰⓱⓲⓳⓴㊀㊁㊂㊃㊄㊅㊆㊇㊈㊉㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⒶⒷⒸⒹⒺⒻⒼⒽⒾⒿⓀⓁⓂⓃⓄⓅⓆⓇⓈⓉⓊⓋⓌⓍⓎⓏⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵﹢﹣×÷±=≌∽≦≧≒﹤﹥≈≡≠=≤≥<>≮≯∷∶∫∮∝∞∧∨∑∏∪∩∈∵∴⊥∥∠⌒⊙√∟⊿㏒㏑%‰⅟½⅓⅕⅙⅛⅔⅖⅚⅜¾⅗⅝⅞⅘≂≃≄≅≆≇≈≉≊≋≌≍≎≏≐≑≒≓≔≕≖≗≘≙≚≛≜≝≞≟≠≡≢≣≤≥≦≧≨≩⊰⊱⋛⋚∫∬∭∮∯∰∱∲∳%℅‰‱øØπ『』〖〗［］《》〔〕{}「」【】︵︷︿︹︽_﹁﹃︻︶︸﹀︺︾ˉ﹂﹄︼❝❞°′″＄￥〒￠￡％＠℃℉﹩﹪‰﹫㎡㏕㎜㎝㎞㏎³㎎㎏㏄º○¤%$º¹²³€£Ұ₴$₰¢₤¥₳₲₪₵₣₱฿¤₡₮₭₩ރ円₢₥₫₦ł﷼₠₧₯₨čर₹ƒ₸￠↑↓←→↖↗↘↙↔↕➻➼➽➸➳➺➻➴➵➶➷➹▶►▷◁◀◄«»➩➪➫➬➭➮➯➱⏎➲➾➔➘➙➚➛➜➝➞➟➠➡➢➣➤➥➦➧➨↚↛↜↝↞↟↠↠↡↢↣↤↤↥↦↧↨⇄⇅⇆⇇⇈⇉⇊⇋⇌⇍⇎⇏⇐⇑⇒⇓⇔⇖⇗⇘⇙⇜↩↪↫↬↭↮↯↰↱↲↳↴↵↶↷↸↹☇☈↼↽↾↿⇀⇁⇂⇃⇞⇟⇠⇡⇢⇣⇤⇥⇦⇧⇨⇩⇪↺↻⇚⇛♐✐✎✏✑✒✍✉✁✂✃✄✆✉☎☏☑✓✔√☐☒✗✘ㄨ✕✖✖☢☠☣✈★☆✡囍㍿☯☰☲☱☴☵☶☳☷☜☞☝✍☚☛☟✌♤♧♡♢♠♣♥♦☀☁☂❄☃♨웃유❖☽☾☪✿♂♀✪✯☭➳卍卐√×■◆●○◐◑✙☺☻❀⚘♔♕♖♗♘♙♚♛♜♝♞♟♧♡♂♀♠♣♥❤☜☞☎☏⊙◎☺☻☼▧▨♨◐◑↔↕▪▒◊◦▣▤▥▦▩◘◈◇♬♪♩♭♪の★☆→あぃ￡Ю〓§♤♥▶¤✲❈✿✲❈➹☀☂☁【】┱┲❣✚✪✣✤✥✦❉❥❦❧❃❂❁❀✄☪☣☢☠☭ღ▶▷◀◁☀☁☂☃☄★☆☇☈⊙☊☋☌☍ⓛⓞⓥⓔ╬『』∴☀♫♬♩♭♪☆∷﹌の★◎▶☺☻►◄▧▨♨◐◑↔↕↘▀▄█▌◦☼♪の☆→♧ぃ￡❤▒▬♦◊◦♠♣▣۰•❤•۰►◄▧▨♨◐◑↔↕▪▫☼♦⊙●○①⊕◎Θ⊙¤㊣★☆♀◆◇◣◢◥▲▼△▽⊿◤◥✐✌✍✡✓✔✕✖♂♀♥♡☜☞☎☏⊙◎☺☻►◄▧▨♨◐◑↔↕♥♡▪▫☼♦▀▄█▌▐░▒▬♦◊◘◙◦☼♠♣▣▤▥▦▩◘◙◈♫♬♪♩♭♪✄☪☣☢☠♯♩♪♫♬♭♮☎☏☪♈ºº₪¤큐«»™♂✿♥　◕‿｡　｡◕‿◕｡ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζνξοπρσηθικλμτυφχψωАБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдеёжзийклмнопрстуфхцчшщъыьэюяāáǎàōóǒòēéěèīíǐìūúǔùǖǘǚǜüêɑńňɡㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ卍卐卄巜弍弎弐朤氺曱甴囍々〆のぁ〡〢〣〤〥〦〧〨〩㊎㊍㊌㊋㊏㊚㊛㊐㊊㊣㊤㊥㊦㊧㊨㊒㊫㊑㊓㊔㊕㊖㊗㊘㊜㊝㊞㊟㊠㊡㊢㊩㊪㊬㊭㊮㊯㊰㊀㊁㊂㊃㊄㊅㊆㊇㊈㊉ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをんゔゕゖァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶヷヸヹヺ・ーヽヾヿ゠ㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ─━│┃╌╍╎╏┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋╪╫╬═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╳╔╗╝╚╬═╓╩┠┨┯┷┏┓┗┛┳⊥﹃﹄┌╮╭╯╰~';
    const specialSymbol = '';
    const newSpecial = specialSymbol.split('');
    const arrVal = Countent.split('');
    const newarr = [];

    for (let i = 0; i < arrVal.length; i++) {
      if (specialSymbol.indexOf(arrVal[i].toString()) > -1) {
        for (let j = 0; j < newSpecial.length; j++) {
          if (arrVal[i] == newSpecial[j]) {
            newarr.push(arrVal[i]);
            break;
          }
        }
      }
    }
    return newarr;
  },
  /**
   * 校验手机号
   * @param str 手机号字符串
   */
  telphoneVerification(str: string): boolean {
    const reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    if (!reg_tel.test(str)) return false;

    return true;
  },
  /** */

  /**
   * 将base46转为Buffer
   * @param {string} s  这是一段base64字符串
   */
  s2ab(s: string): ArrayBuffer {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
  },

  /**
   * 下载文件时使用
   * @param {Object} data 这是一个对象 {data: "这是一段base64字符串", filename: "文件名", resp_code: 0, resp_msg: "", success: true}
   *
   * @description 使用方法：页面中直接调用 utils.downloadFile(res);
   * */
  downloadFile(data: { data: string; filename: string; resp_code: number; resp_msg: string; success: boolean,downloadType:string }): void {
    const blob = new Blob([this.s2ab(window.atob(data.data))], { type: 'application/octet-stream' });
    // var blob = new Blob([decodeURIComponent(escape(window.atob((data).replace(/-/g, "+").replace(/_/g, "/"))))], { type: "application/octet-stream" });

    // 创建a标签并点击， 即触发下载
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none');
    a.setAttribute('href', objectUrl);
    a.setAttribute('download',
     data.filename && data.filename !== '' ?
     data.downloadType && data.downloadType!==''? `${data.filename}.${data.downloadType}`:`${data.filename}.xlsx` : `导出数据${moment().format('YYYY-MM-DD')}.xlsx`);
    a.click();
    URL.revokeObjectURL(objectUrl);
  },

  /**
   * 处理浏览器数字计算后产生的精度失真问题
   * @param {number} num 需要转化你的数字
   * @param {number} decimal 保留的小数位，默认保留2位小数
   * @returns number
   */
  numberTransform(num: number, decimal = 2): number {
    // const deci = Math.pow(10, decimal); //ES5语法
    // const deci = 10 ** decimal; //ES7语法
    return num ? parseFloat((num * (Math.pow(10, decimal))).toFixed(2)) : 0;
  },

  /**
   * json对象和url参数互转 start
   * @param data 需要转换为字符串拼接的对象
   * @param isPrefix 是否需要再转换后的字符串前加?
   * @returns ?a=a&b=b || a=a&b=b
   */
  queryParams(data: object, isPrefix = true): string {
    const prefix = isPrefix ? '?' : '';
    const _result = [] as string[];
    for (const key in data) {
      const value = data[key];
      // 去掉为空的参数
      if (['', undefined, null].includes(value)) {
        continue;
      }
      if (value.constructor === Array) {
        value.forEach((_value) => {
          _result.push(`${encodeURIComponent(key) }[]=${ encodeURIComponent(_value)}`);
        });
      } else {
        _result.push(`${encodeURIComponent(key) }=${ encodeURIComponent(value)}`);
      }
    }
    return _result.length ? prefix + _result.join('&') : '';
  },
  calcSmsNumber(smsContent, smsSign) {
    let num = 0;
    if ((smsSign?.length + smsContent + CANCELWDLENGTH)?.length <= 70) {
      num = Math.ceil(
        (smsSign?.length + smsContent?.length + CANCELWDLENGTH) / 70
      );
    } else if ((smsSign?.length + smsContent + CANCELWDLENGTH)?.length > 70) {
      num = Math.ceil(
        (smsSign?.length + smsContent?.length + CANCELWDLENGTH) / 67
      );
    }
    return num;
  },
    // 退订文案长度，查看时，上线那一刻，之前的任务都不裁掉回T退，不拼新退订文案，其他的都正常处理。 2是 【】
  calcCancelLength(bool) {
    return bool ? 2 : CANCELWDLENGTH;
  },
  /**
   * @description: 计算短信内容长度是几条短信
   * @param {*} sign 短信签名
   * @param {*} content 短信内容（不包含退订文案等）
   * @param {*} bool 是否处理回T退
   * @return {*}
   */
  checkSmsContentLength(sign, content, bool) {
    let tempCount = 1;
    const len = sign.length + content.length + this.calcCancelLength(bool);
    if (len <= 70) {
      tempCount = Math.ceil(
        len / 70
      );
    } else if (len > 70) {
      tempCount = Math.ceil(
        len / 67
      );
    }
    return tempCount;
  },
};
